import { Grid, Row, theme } from "antd";
import React from "react";

import { JobLocationFilter } from "./JobLocationFilter";
import { JobTypeFilter } from "./JobTypeFilter";
import { SearchBar } from "./SearchBar";
import { PrimaryControlsCol, PrimaryControlsRoot, SearchButton } from "./styled";
import { PrimaryControlsProps } from "./types";

export const PrimaryControls: React.FC<PrimaryControlsProps> = ({
  queryState,
  queryDispatch,
  instantSearch,
  onSearchClick,
}) => {
  const { token } = theme.useToken();
  const breakpoints = Grid.useBreakpoint();

  const isMobileDisplay = !breakpoints.lg;

  return (
    <PrimaryControlsRoot $isInstantSearch={instantSearch} $token={token}>
      <PrimaryControlsCol id="cell-one">
        <Row>
          <SearchBar queryState={queryState} queryDispatch={queryDispatch} />
          {!isMobileDisplay && <JobTypeFilter queryState={queryState} queryDispatch={queryDispatch} />}
        </Row>
      </PrimaryControlsCol>
      <PrimaryControlsCol id="cell-two">
        <Row>
          <JobLocationFilter queryState={queryState} queryDispatch={queryDispatch} />
          {isMobileDisplay && <JobTypeFilter queryState={queryState} queryDispatch={queryDispatch} />}
          {!instantSearch && (
            <SearchButton $token={token} onClick={onSearchClick}>
              {"Search"}
            </SearchButton>
          )}
        </Row>
      </PrimaryControlsCol>
    </PrimaryControlsRoot>
  );
};
